'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = template;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../style/index');

var _index2 = _interopRequireDefault(_index);

var _Input = require('../../Input');

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function template() {
    var _this = this;

    var list = null,
        classList = this.compileStyle(_index2.default),
        collection = void 0;

    if (this.state.active) {
        collection = this._filter();

        if (collection.length) {
            list = collection.map(function (child, i) {
                return _react2.default.createElement(
                    'button',
                    {
                        key: 'autoCompleteItem' + child.props.value + i,
                        type: 'button',
                        className: classList.item + ' ' + (_this.state.focused === i ? 'focused' : ''),
                        onClick: function onClick(e) {
                            return _this.select(child);
                        },
                        title: child.props.value || ''
                    },
                    child
                );
            });

            list = _react2.default.createElement(
                'div',
                { className: classList.list },
                list
            );
        }

        this._currentFilteredList = collection;
    }

    return _react2.default.createElement(
        'div',
        { className: classList.root + ' ' + (this.props.className || '') },
        _react2.default.createElement(_Input2.default, _extends({}, this.props, {
            style: null,
            className: '',
            theme: this._inputTheme(),
            elementRef: this._inputRef.bind(this),
            onChange: this._handleChange.bind(this),
            onKeyDown: this._handleKeyDown.bind(this),
            onFocus: this._handleFocus.bind(this),
            onBlur: this._handleBlur.bind(this),
            value: this.state.query || ''
        })),
        list
    );
}